const environment = process.env.NEXT_PUBLIC_DEPLOY_NAMESPACE || '';

export const isProduction = () => environment === 'production';
